import React from 'react';
import { useQuery } from 'convex/react';
import { api } from '../lib/convex';
import { cn } from '@/lib/utils';

export default function UsageIndicator() {
  const preferences = useQuery(api.posts.getUserPreferences);
  
  if (!preferences) return null;

  const limit = preferences.monthlyLimit;
  const usage = preferences.monthlyUsage || 0;
  const percentage = (usage / limit) * 100;

  const getProgressColor = () => {
    if (percentage > 90) return 'bg-red-600';
    if (percentage > 75) return 'bg-yellow-600';
    return 'bg-blue-800';
  };

  return (
    <div className="relative group">
      <div className="w-32 h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className={cn(
            "h-full transition-all duration-300",
            getProgressColor()
          )}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <div className="mt-1 text-xs text-gray-600">
        {usage} / {limit} posts
      </div>
    </div>
  );
}